import React from 'react';
import { SearchBar } from 'components/shared/SearchBar/SearchBar';
import { LogoImage } from '../BrandImages';
import { FlexRow } from '../FlexRow';
import { HeaderShadowWrapper } from '../HeaderShadowWrapper';
import { NavigationItem } from '../Navigation';
import { SpacerRow } from '../SpacerRow';
import { HeaderPaddingWrapper, HeaderTitleWrapper } from './Header.styles';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

export interface IWorkflowHeaderProps {
  /** A callback fired when the "left arrow" is clicked. */
  onBackClick: () => void;
  /** A callback fired when the "logo" is clicked. */
  onHomeClick?: () => void;
  /** A label for the 'back' button which can show Save & Exit or Cancel */
  labelBack?: 'Save & Exit' | 'Cancel' | 'Exit';
  logoLink?: string;
  /** Main heading text. */
  title?: string | null;
  children?: React.ReactNode;
}

export const WorkflowHeader: React.FC<IWorkflowHeaderProps> = ({
  onBackClick,
  onHomeClick,
  children,
  labelBack = 'Save & Exit',
  logoLink,
  title,
}) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  return (
    <HeaderShadowWrapper useDefaultBackground={isZillowClosingEnabled}>
      <HeaderPaddingWrapper>
        <FlexRow justifyContent={'space-between'}>
          <FlexRow verticalAlign={'center'}>
            <NavigationItem text={'Logo'} onClick={onHomeClick} to={logoLink}>
              <LogoImage />
            </NavigationItem>
          </FlexRow>
          <SearchBar />
          <FlexRow verticalAlign={'center'}>
            <NavigationItem data-id={`Sign Out`} text={labelBack!} onClick={onBackClick} />
          </FlexRow>
        </FlexRow>
        <SpacerRow />
        <FlexRow justifyContent={'space-between'}>
          <FlexRow verticalAlign={'center'}>{title ? <HeaderTitleWrapper>{title}</HeaderTitleWrapper> : null}</FlexRow>
          <FlexRow verticalAlign={'center'}>{children}</FlexRow>
        </FlexRow>
      </HeaderPaddingWrapper>
    </HeaderShadowWrapper>
  );
};
